// extracted by mini-css-extract-plugin
module.exports = {"container":"TabNavigator-module--container--1OcYi","tabList":"TabNavigator-module--tab-list--3pgVJ","active":"TabNavigator-module--active--1LQoP"};